const BUILD_TIMESTAMP = import.meta.env.VITE_BUILD_TIMESTAMP ?? ''

export function getBuildTimestamp(): string {
  return BUILD_TIMESTAMP
}

/** Short label for the footer, e.g. 20260519 */
export function formatBuildVersionLabel(iso: string): string | null {
  if (!iso) return null
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return null
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}`
}

/** Full release time for native `title` tooltip */
export function formatBuildVersionTitle(iso: string): string | null {
  if (!iso) return null
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  return `Release ${d.toLocaleString(undefined, {
    dateStyle: 'full',
    timeStyle: 'medium',
  })}`
}
